import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getTranslation, getLink, getSetting } from '../service/asset-json';
import { Container, Wrapper, Logo, BusinessAccount } from '../login/login.component.styles';
import { Login } from './signup.component.styles';
import { ConnectedSignupForm } from '../signup-form/signup-form.component';
import gogoxLogo from '../assets/gogox-logo.svg';
import UpdateUserInfoModule from '../components/Login/UpdateUserInfoModule';
import Layout from '../components/Layout/Layout';

const Signup = ({ currentLocale }) => {
  const LoginLink = (
    <Login>
      {getTranslation('have_account', currentLocale)}
      <a target="_blank" href={getLink('sign_in', currentLocale)}>
        {` ${getTranslation('login', currentLocale)}`}
      </a>
    </Login>
  );

  const BusinessLink = (
    <BusinessAccount>
      {getTranslation('business_account', currentLocale)}
      <a target="_blank" href={getLink('gogobusiness', currentLocale)}>
        {` ${getTranslation('click_here', currentLocale)}`}
      </a>
    </BusinessAccount>
  );

  const hasGogobusiness = getSetting('gogobusiness', currentLocale);

  const BusinessSignupLink = (
    <BusinessAccount>
      {getTranslation('sign_up_business', currentLocale)}
      <a target="_blank" href={getLink('sign_up_business', currentLocale)}>
        {` ${getTranslation('click_here', currentLocale)}`}
      </a>
    </BusinessAccount>
  );

  return  (
    <Layout showHeader={false} showFooter={false}>
      <Container>
        <Wrapper>
          <Logo src={gogoxLogo} alt="GOGOX" />
          <ConnectedSignupForm />
          {LoginLink}
          {hasGogobusiness && BusinessLink}
          { currentLocale === 'en-SG' && BusinessSignupLink }
        </Wrapper>
        <UpdateUserInfoModule />
      </Container>
    </Layout>
  );
};

Signup.propTypes = {
  currentLocale: PropTypes.string.isRequired,
};

const mapState = state => ({
  currentLocale: state.intl.locale,
});

const ConnectedSignup = connect(mapState)(Signup);

export { ConnectedSignup };



// WEBPACK FOOTER //
// ./src/signup/signup.component.js